import { createApp } from 'vue';
import BookButton from './Event/BookButton.vue';
import Calendar from './Calendar/Calendar.vue';
import Blogs from './Blogs/Blogs.vue';
import Search from './Search/Search.vue';
import { Dropdown } from "floating-vue";

import { initFeatures } from './services/features.js';
await initFeatures('..');

let app = null;

document.addEventListener('DOMContentLoaded', () => {
    const mountPoint = document.querySelector('#widget-bootstrap');
    if (!mountPoint) {
        console.error('Mount point #widget-bootstrap is missing.');
        return;
    }

    if (mountPoint.__vue_app__) {
        return;
    }

    const App = {
        data() {
            return {};
        },
        delimiters: ['${', '}']
    }

    app = createApp(App);

    app.component('book-button', BookButton);
    app.component('calendar', Calendar);
    app.component('blogs', Blogs);
    app.component('search', Search);
    app.component('v-dropdown', Dropdown);
    app.mount(mountPoint);

    mountPoint.__vue_app__ = app;
});
